<template>
  <label class="cb-container" :class="'cb-container-' + size">
    {{ label }}
    <input type="checkbox" v-model="value" :disabled="disabled" />
    <span
      class="checkmark"
      :class="[{ disabled: disabled }, 'size-' + size]"
    ></span>
  </label>
</template>

<script>
export default {
  props: {
    label: { type: String },
    size: { type: String, default: 'normal' },
    checked: { type: Boolean, required: true },
    disabled: { type: Boolean, required: false, default: false }
  },
  computed: {
    value: {
      get: function() {
        return this.checked;
      },
      set: function() {
        this.$emit('change');
      }
    }
  }
};
</script>
<style scoped lang="scss">
.disabled {
  cursor: not-allowed;
}
.cb-container {
  display: inline-block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cb-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  // top: 4px;
  left: 0;
  background-color: rgb(207, 207, 207);
}

.cb-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.cb-container input:checked ~ .checkmark {
  background-color: var(--primary-color);
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.cb-container input:checked ~ .checkmark:after {
  display: block;
}

.cb-container-normal .checkmark:after {
  left: 8px;
  top: 4px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.cb-container-small .checkmark:after {
  left: 4px;
  top: 1px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.size-normal {
  width: 25px;
  height: 25px;
}

.size-small {
  width: 1rem;
  height: 1rem;
}
</style>
